module.exports = "pegasus/assets/blocks/column-lp0-themelp1.png";